import { TableRow } from '@mui/material';

import { InfoWalkmeCrumb } from 'features/info_hover/InfoHover';

import { StyledCell } from './shared-ui';

import styles from '../Taskbar.module.css';

export function SegmentProperties({
  freeflowSpeed,
  name,
}: {
  freeflowSpeed: string;
  name: string;
}) {
  return (
    <>
      {name && (
        <TableRow>
          <StyledCell colSpan={2} className={styles.TableCell}>
            {name}
          </StyledCell>
        </TableRow>
      )}
      {freeflowSpeed != null && (
        <TableRow>
          <StyledCell>
            Freeflow speed
            <InfoWalkmeCrumb elId="freeflow-speed" />
          </StyledCell>
          <StyledCell>{freeflowSpeed}</StyledCell>
        </TableRow>
      )}
    </>
  );
}
